(function(){
  var rm = window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  // sticky nav
  var nav = document.getElementById('nav');
  function onScroll(){ nav.classList.toggle('solid', window.scrollY > 40); }
  onScroll(); window.addEventListener('scroll', onScroll, {passive:true});

  // mobile menu
  var burger=document.getElementById('burger'), mmenu=document.getElementById('mmenu'), mclose=document.getElementById('mclose');
  function openM(){mmenu.classList.add('open')} function closeM(){mmenu.classList.remove('open')}
  burger.addEventListener('click',openM); mclose.addEventListener('click',closeM);
  mmenu.querySelectorAll('a').forEach(function(a){a.addEventListener('click',closeM)});

  // reveal on scroll
  var rv=document.querySelectorAll('.rv');
  if(rm){ rv.forEach(function(e){e.classList.add('in')}); }
  else{
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });
    },{threshold:.14, rootMargin:'0px 0px -40px 0px'});
    rv.forEach(function(e){io.observe(e)});
  }

  // count-up
  var counted=false;
  function runCount(){
    if(counted) return; counted=true;
    document.querySelectorAll('[data-count]').forEach(function(el){
      var target=+el.getAttribute('data-count'), suf=el.getAttribute('data-suf')||'', t0=null, dur=1400;
      if(rm){ el.textContent=target+suf; return; }
      function tick(ts){ if(!t0)t0=ts; var p=Math.min((ts-t0)/dur,1); var e=1-Math.pow(1-p,3);
        el.innerHTML=Math.round(target*e)+(suf?'<span class="suf">'+suf+'</span>':''); if(p<1)requestAnimationFrame(tick);}
      requestAnimationFrame(tick);
    });
  }
  var statsEl=document.querySelector('.stats-grid');
  if(statsEl){
    var io2=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){runCount();io2.disconnect();}})},{threshold:.4});
    io2.observe(statsEl);
  }

  // before / after slider
  var ba=document.getElementById('ba'), before=document.getElementById('baBefore'), handle=document.getElementById('baHandle');
  if(ba){
    var dragging=false;
    function setPos(clientX){
      var r=ba.getBoundingClientRect();
      var x=Math.max(0,Math.min(1,(clientX-r.left)/r.width));
      var pct=(x*100).toFixed(2);
      before.style.clipPath='inset(0 '+(100-pct)+'% 0 0)';
      handle.style.left=pct+'%';
    }
    function down(e){dragging=true; setPos((e.touches?e.touches[0]:e).clientX);}
    function move(e){ if(!dragging) return; if(e.touches)e.preventDefault(); setPos((e.touches?e.touches[0]:e).clientX);}
    function up(){dragging=false;}
    ba.addEventListener('mousedown',down); window.addEventListener('mousemove',move); window.addEventListener('mouseup',up);
    ba.addEventListener('touchstart',down,{passive:true}); window.addEventListener('touchmove',move,{passive:false}); window.addEventListener('touchend',up);
    // subtle intro nudge
    if(!rm){ setTimeout(function(){ setPos(ba.getBoundingClientRect().left+ba.getBoundingClientRect().width*0.62);},700);
             setTimeout(function(){ setPos(ba.getBoundingClientRect().left+ba.getBoundingClientRect().width*0.5);},1100); }
  }

  // form (front-only demo)
  var sb=document.getElementById('sendBtn');
  if(sb){ sb.addEventListener('click',function(){
    sb.textContent='Demande envoyée ✓'; sb.style.background='#176312';
    setTimeout(function(){ sb.innerHTML='Envoyer ma demande <span class="ar">→</span>'; sb.style.background='';},2600);
  });}

  document.getElementById('yr').textContent=new Date().getFullYear();

  // project gallery
  var thumbs=document.getElementById('pjThumbs');
  if(thumbs){
    var mainPhoto=document.getElementById('pjMainPhoto');
    var counter=document.getElementById('pjCounter');
    var allThumbs=thumbs.querySelectorAll('.pj-thumb');
    var total=allThumbs.length;
    var current=0;

    function goTo(idx){
      if(idx<0) idx=total-1;
      if(idx>=total) idx=0;
      current=idx;
      allThumbs.forEach(function(b){b.classList.remove('active')});
      allThumbs[current].classList.add('active');
      mainPhoto.style.opacity='0';
      setTimeout(function(){
        mainPhoto.src=allThumbs[current].getAttribute('data-src');
        mainPhoto.alt=allThumbs[current].getAttribute('data-alt')||'';
        mainPhoto.style.opacity='1';
      },180);
      if(counter) counter.textContent=(current+1)+' / '+total;
      allThumbs[current].scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
    }

    allThumbs.forEach(function(btn,i){
      btn.addEventListener('click',function(){ goTo(i); });
    });

    var prevBtn=document.getElementById('pjPrev');
    var nextBtn=document.getElementById('pjNext');
    if(prevBtn) prevBtn.addEventListener('click',function(){ goTo(current-1); });
    if(nextBtn) nextBtn.addEventListener('click',function(){ goTo(current+1); });

    // keyboard
    document.addEventListener('keydown',function(e){
      if(!document.getElementById('pjMainImg')) return;
      if(e.key==='ArrowLeft') goTo(current-1);
      if(e.key==='ArrowRight') goTo(current+1);
    });
  }
})();
